import { makeStyles } from '@mui/styles';
export default makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
  avatar: {
    margin: theme.spacing(1),
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    marginTop: "10px",
  marginBottom: "10px",
  },
 googleButton: {
  marginTop: "10px",
  marginBottom: "10px",
  width: "100%",

  "& button": {
    width: "100%",
  },
},
}));